<template>
  <div class="header">
    <svg
      v-on:click="showUserMenu"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 20H35"
        stroke="black"
        stroke-width="3.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 10H35"
        stroke="black"
        stroke-width="3.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 30H35"
        stroke="black"
        stroke-width="3.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <div class="page-details">
      <img src="../assets/logo2.png" alt="WCF logo" class="wcf-logo" /> |
      <p class="page-name">{{ pageName }}</p>
    </div>
    <div class="user-details" v-on:click="showUserPopUp">
      <div class="user-profile-stroke">
        <img src="../assets/user.png" alt="" class="user-profile-photo" />
      </div>
    </div>
    <PopUpMenu v-if="popupActive === true" :userName="user" />
    <WebMenu v-if="showMenu === true" />
  </div>
</template>

<script>
import PopUpMenu from "@/components/Header/UserPopupMenu.vue";
import WebMenu from "@/components/Menu.vue";

export default {
  name: "PageHeader",
  data() {
    return {
      user: "Tyla Jones",
      popupActive: false,
      showMenu: false,
    };
  },
  props: {
    pageName: String,
  },
  components: {
    PopUpMenu,
    WebMenu,
  },
  methods: {
    showUserPopUp() {
      this.popupActive = !this.popupActive;
    },
    showUserMenu() {
      this.showMenu = !this.showMenu;
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100vw;
  padding: 1.037vw 1.389vw;
  display: flex;
  align-items: center;
  gap: 2.778vw;
  background: transparent;
  background-color: #f3f3f3;
  position: fixed;
  z-index: 5;
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
  svg {
    cursor: pointer;
    width: 2.315vw;
    height: 2.315vw;
  }
  .page-details {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 2.778vw;
    color: var(--black);
    font-family: "DM Sans";
    font-size: 1.389vw;
    font-style: normal;
    font-weight: var(--medium-heavy);
    line-height: normal;
    letter-spacing: -0.06rem;
    img {
      width: 2.315vw;
      height: 2.315vw;
      border-radius: 50%;
    }
    p {
      color: var(--black);
      font-family: "DM Sans";
      font-size: 1.389vw;
      font-style: normal;
      font-weight: var(--medium-heavy);
      line-height: normal;
      letter-spacing: -0.06rem;
    }
  }
  .user-details {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    .user-profile-stroke {
      border-radius: 50%;
      display: flex;
      padding: 0.463vw;
      justify-content: center;
      align-items: center;
      gap: 0.579vw;
      border: 4px solid var(--accent-colour);
      cursor: pointer;
      img {
        width: 2.315vw;
        height: 2.315vw;
      }
    }
  }
}
</style>
